@use "../../../assets/styles/abstracts/variables" as v;
@use "../../../assets/styles/abstracts/mixins/typography" as t;

.phoneCode {
  width: 95px;
  padding: 13px 0px 13px 16px;
  display: flex;
  align-items: center;
  gap: 11px;
  flex-shrink: 0;
  cursor: pointer;
  position: relative;
}

.phoneCodeDisabled {
  cursor: not-allowed;
  pointer-events: none;
}

.phoneCodeFlag {
  width: 24px;
  height: 16px;
  object-fit: cover;
  border-radius: 2px;
  flex-shrink: 0;
}


.phoneCodeInput {
  width: 36px;
  flex-shrink: 0;
  padding: 0;
  border: none;
  background: transparent;
  color: v.$palette-white;
  @include t.text(14px, 22px, "normal");
  cursor: pointer;
}

.openListIcon {
  position: absolute;
  right: -10px;
  flex-shrink: 0;
  transition: transform 0.3s ease-in-out;
}

.openListIconActive {
  transform: rotate(180deg);
}

.loader {
  width: 80px;
}

.phoneCodeInputDisabled {
  color: v.$palette-gray-700;
}

.openListIconDisabled {
  opacity: 0.3;
}